import { useState } from 'react';
import '../styles/App.css';
import 'leaflet/dist/leaflet.css';
import EasyCrop from '../components/EasyCrop';
import { getCroppedImg } from "../cropUtils";
import { Area } from 'react-easy-crop';

function App() {
  const [showPopup, setShowPopup] = useState(false);
  const [showPopupClose, setshowPopupClose] = useState(false);
  const [statusText, setStatusText] = useState("Identifying Fish");
  const handleSendToApi = async (imageUrl: string | undefined, croppedAreaPixels: Area | null, rotation: number | null) => {
    if (!croppedAreaPixels) return;
    if (!imageUrl) return;
    if (!rotation) rotation = 0
    const croppedBlob = await getCroppedImg(imageUrl, croppedAreaPixels, rotation);
    const formData = new FormData();
    formData.append("image", croppedBlob, "cropped.jpg");

    setShowPopup(true);
    setshowPopupClose(false);
    setStatusText("Identifying Fish");



    try {
      const response = await fetch("http://127.0.0.1:5000/predict", {
        method: "POST",
        body: formData,
      });


      if (!response.ok) {
        const errorText = await response.text();
        throw new Error(`Server error: ${response.status} - ${errorText}`);
      }

      const data = await response.json();
      console.log("Prediction:", data);
      setStatusText(`Identified ${data.predicted_class} with ${(data.confidence*10).toFixed(2)}% confidence`);
      setshowPopupClose(true);
    } catch (err) {
      console.error("Error parsing response:", err);
      setStatusText("HTTP Error: Please try again.");
      setshowPopupClose(true);
    }
  };



  return (
    <div>
      <h1 className="p-10 text-5xl font-bold text-blue-600 text-center">AI Identifier</h1>
      <h1 className="text-1xl text-gray-200 text-center">
        Upload an image to send to the AI
      </h1>
      <EasyCrop
        onAction={handleSendToApi}
        actionLabel = "Send to AI"
      />

      <>
        {/* Overlay */}
        {showPopup && (
          <div className="fixed inset-0 flex items-center justify-center bg-black/50 z-[101]">
            {/* Popup Box */}
            <div className="bg-gray-900 rounded-2xl shadow-xl p-3 w-80 text-center">
              <h2 className="text-3xl font-semibold mb-2">Status</h2>
              {!showPopupClose && (
              <div className="flex justify-center">
                <div className="w-12 h-12 border-4 border-blue-500 border-t-transparent rounded-full animate-spin"></div>
              </div>
              )}
              <p className="text-gray-600 mb-4">
                {statusText}
              </p>
              {showPopupClose && (
              <button
                onClick={() => setShowPopup(false)}
                className="px-4 py-2 bg-blue-600 text-white rounded-lg hover:bg-blue-700 transition"
              >
                Close
              </button>
              )}
            </div>
          </div>
        )}
      </>

    </div>
  );
}

export default App;
